import React from 'react';
import { Modal, Button, Table, Upload, message } from 'antd';
import FileStep from '../../../../components/FileStep';
import { downloadFile } from '../../../../utils/index';
import { getTemplateByImportAssignment, getAssignmentReportsByFile, getAssignmentInfoByFile } from '../../../../service/report';
import { ColumnType, FileResultType, AssignmentInfoResult } from './types';


interface IProps {
  onCancel?: () => void
  callback?: (result: AssignmentInfoResult) => void
  visible: boolean
}

interface IState {
  step: number
  isRecognizing: boolean
  isUploading: boolean
  fileResult: FileResultType
}

const columns: ColumnType[] = [
  {
    title: '行数',
    dataIndex: 'line',
    width: 70
  },
  {
    title: '受理号',
    dataIndex: 'flowId',
    width: 180
  },
  {
    title: '错误原因',
    dataIndex: 'errorMsg',
    render: text => <p style={{ color: '#FF1414' }}>{text}</p>
  },
];

const uploadProps = {
  multiple: false,
  accept: '.xls,.xlsx,.csv',
  showUploadList: false,
  beforeUpload(file) {
    const fileType = file.name.split('.').pop();
    const isFile = ['xls', 'xlsx', 'csv'].includes(fileType);
    if (!isFile) {
      message.error('导入文件，支持xls、xlsx、csv');
      return false;
    }
    return isFile;
  }
}

export default class ImportAssignmentReport extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      // 1上传、解析文件，2文件解析错误，3解析成功，上传
      step: 1,
      // 导入loading
      isUploading: false,
      // 解析loading
      isRecognizing: false,
      fileResult: { notExistsFlowIds: [] }
    } as IState
  }

  initState = () => {
    this.setState({
      step: 1,
      isUploading: false,
      fileResult: { notExistsFlowIds: [] } as FileResultType
    })
  }
  // 取消弹框
  handleCancel = () => {
    this.props.onCancel && this.props.onCancel();
    this.setState({
      step: 1,
      isUploading: false
    })
  }

  getTitle = () => {
    const { step } = this.state;
    switch (step) {
      case 2:
        return '错误数据如下';
      default:
        return '导入案件清单进行指派'
    }
  }

  // 下载文件示例
  downloadTemplate = async () => {
    try {
      const { result } = await getTemplateByImportAssignment();
      downloadFile(result.fileUrl);
    } catch { }
  }

  handleUpload = async ({ file }) => {
    try {
      const formData = new FormData();// 创建form对象
      formData.append('file', file);
      this.setState({
        isRecognizing: true
      })
      const { result }: { result: FileResultType } = await getAssignmentReportsByFile(formData, { 'Content-Type': 'multipart/form-data' });
      // 解析成功，进行导入校验流程；解析失败，展示错误数据列表
      if (result.notExistsFlowIds.length) {
        this.setState({
          step: 2,
          isRecognizing: false,
          fileResult: result
        })
      } else {
        const { result: assignmentResult }: { result: AssignmentInfoResult } = await this.getFlowInfo(result.fileId);
        this.setState({
          isRecognizing: false
        }, () => {
          this.props.callback && this.props.callback({...assignmentResult, fileId: result.fileId });
        })
      }
    } catch {
      this.setState({
        isRecognizing: false
      })
    }
  }

  getFlowInfo = async <T,>(fileId: T)  => {
    return await getAssignmentInfoByFile({ file: fileId })
  }

  handleAssign = async () => {
    const { fileResult } = this.state;
    const { result: assignmentResult }: { result: AssignmentInfoResult } = await this.getFlowInfo(fileResult.fileId)
    this.setState({
      step: 1
    })
    this.props.callback && this.props.callback({...assignmentResult, fileId: fileResult.fileId });
  }

  render() {
    const { step, isRecognizing, fileResult } = this.state, { visible } = this.props;
    return <Modal
        title={this.getTitle()}
        visible={visible}
        footer={null}
        onCancel={this.handleCancel}
        width={700}
        destroyOnClose
        maskClosable={false}
        bodyStyle={{ padding: '20px 40px' }}
      >
        {/* 导入文件弹框 */}
        {
          step === 1 ? <FileStep content={[
            ["第一步：下载导入案件清单的模板文件", <Button type="primary" size="small" onClick={this.downloadTemplate}>下载模板</Button>],
            ['第二步：将案件清单整理到下载好的模板文件（必须严格按照模板）'],
            ['第三步：将整理好的文件上传导入', <React.Fragment>
              {
                isRecognizing ? <Button type="primary" size="small" loading={isRecognizing}>解析中</Button> : <Upload {...uploadProps} customRequest={this.handleUpload}>
                  <Button type="primary" size="small">导入文件</Button>
                </Upload>
              }
            </React.Fragment>]]} /> : null
        }
        {/* 错误列表展示 */}
        {
          step === 2 ? <React.Fragment>
            <Table bordered columns={columns} dataSource={fileResult.notExistsFlowIds} size="small" pagination={false} scroll={{ y: 300 }} />
            <div className="align-right" style={{ marginTop: 15 }}>
              {/* 解析的案件若有错误，则需判断是否有正确的案件 */}
              {
                fileResult.succFlowIdNum ? <Button danger size="small" className="margin-right" onClick={this.handleAssign}>继续指派</Button> : null
              }
              <Button type="primary" size="small" onClick={() => this.setState({ step: 1 })}>重新操作</Button>
            </div>
          </React.Fragment> : null
        }
      </Modal>
  }
}